import { Reveal, Overline } from "./Reveal";
import { VALUES } from "@/data/content";

export const Values = () => (
  <section id="values" data-testid="values-section" className="bg-cream-dark py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mb-12 max-w-2xl">
        <Overline>Core Values</Overline>
        <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
          The Values That Guide My Work
        </h2>
      </Reveal>
      <div className="flex flex-wrap gap-3.5">
        {VALUES.map((v, i) => (
          <Reveal key={v} delay={i * 0.06}>
            <span
              data-testid={`value-chip-${i}`}
              className="inline-block cursor-default rounded-full border border-peach/30 bg-white px-6 py-3.5 font-heading text-sm font-semibold text-ink transition-[background-color,color,border-color,transform] duration-400 hover:-translate-y-1 hover:border-peach-dark hover:bg-peach-dark hover:text-cream sm:text-base"
            >
              {v}
            </span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
